import { Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../../../localization'
import useStyles from './styles/index.styles'

type Props = { availableRoom: number }

const RoomAvailable = ({ availableRoom }: Props) => {
  const classes = useStyles()
  const isWarning = availableRoom < 5

  return (
    <div className={[classes.root, isWarning && classes.warningRoot].join(' ')}>
      <Typography
        variant="h6"
        className={[classes.title, isWarning && classes.warningTitle].join(
          ' '
        )}>{`${availableRoom} ${getTranslate('rooms available')} `}</Typography>
    </div>
  )
}

export default RoomAvailable
